<template>
  <FullScreenDialog
    v-model="enablingTypeCategoryDialog"
    title="Categorie Tipi Abilitazione"
    :routeFather="pathToGoBack"
  >
    <template v-slot:toolbar-extension>
      <v-tabs v-model="tab" align-with-title>
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          v-for="tab in enablingTypeCategoryTabs"
          :key="tab.key"
          @click="$router.push({ name: tab.routeName }).catch(() => {})"
          >{{ tab.title }}</v-tab
        >
      </v-tabs>
    </template>
    <template v-slot:content>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="tabItem in enablingTypeCategoryTabs" :key="tabItem.key">
          <v-card flat>
            <router-view></router-view>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </template>
    <template v-slot:footer-actions>
      <v-spacer></v-spacer>
      <v-btn
        text
        color="error"
        @click="$router.push({path: pathToGoBack})"
      >Annulla</v-btn>
      <v-btn
        text
        color="default"
        :disabled="!formValid"
        @click="submitForm"
        :loading="loading"
      >Salva</v-btn>
    </template>
  </FullScreenDialog>
</template>

<script>
import FullScreenDialog from "@/components/common/FullScreenDialog.vue";
import enablingTypeCategoriesService from '@/services/enablingTypeCategories/enablingTypeCategories.service.js'
import enablingTypeCategoryForm from '@/services/enablingTypeCategories/enablingTypeCategory.form.js'

export default {
  name: "EnablingTypeCategoriesRegistryNewForm",
  components: {
    FullScreenDialog
  },
  data: function() {
    return {
      tab: null,
      enablingTypeCategoryDialog: this.openDialog,
      enablingTypeCategoryTabs: this.tabs,
      formValid: false,
      enablingTypeCategory: undefined,
      loading: false
    };
  },
  mounted() {
    this.changeTabBasedOnRoute(this.$route.name)

    let self = this
    enablingTypeCategoryForm.resetEnablingTypeCategory()
    enablingTypeCategoryForm.on('update', function(data) {
      self.enablingTypeCategory = data.enablingTypeCategory
    })

    enablingTypeCategoryForm.on('valid-change', function(data) {
      self.formValid = data
    })
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    pathToGoBack: {
      type: String,
      default: "/registries"
    },
    tabs: {
      type: Array,
      default: function() {
        return [
          {
            key: 0,
            title: "Generale",
            routeName: "EnablingTypeCategoriesGeneralNewFormTab",
          }
        ];
      }
    }
  },
  methods: {
    changeTabBasedOnRoute(routeName) {
      for(let i = 0; i < this.tabs.length; i++) {
        if(this.tabs[i].routeName == routeName) {
          this.tab = i
          break
        }
      }
    },
    submitForm() {
      this.loading = true
      enablingTypeCategoriesService.create(this.enablingTypeCategory).then((result) => {
        this.loading = false
        this.$router.push({path: this.pathToGoBack})
      })
    }
  },
  watch: {
    openDialog(newVal) {
      this.enablingTypeCategoryDialog = newVal;
    }
  },
  computed: {
  }
};
</script>

<style>
</style>